import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Typography } from 'antd';

function ConfirmRevisionModal({ isVisible, onSubmit, onCancel, loading }) {
  return (
    <Modal
      width={600}
      style={{ padding: '10px' }}
      title={
        <Typography style={{ margin: 0, textAlign: 'center', fontSize: '20px' }}>
          Confirm Revision Request
        </Typography>
      }
      open={isVisible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel} type="default">
          Go Back
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={onSubmit}>
          Submit
        </Button>
      ]}
      centered
      closable
    >
      <Typography style={{ fontSize: '15px' }}>
        Your pricing revision request will be sent for internal review. Once approved, the new rates
        will be applied automatically.
      </Typography>
    </Modal>
  );
}

ConfirmRevisionModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default ConfirmRevisionModal;
